import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClipboardModule } from 'ngx-clipboard';

@Component({
    standalone: true,
    selector: 'sh-copy-button',
    templateUrl: './copy-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ClipboardModule]
})
export class CopyButtonComponent implements OnInit {
    public container: HTMLElement | null;

    @Input() data: string;
    @Input() label: string;
    @Input() disabled: boolean = false;
    @Input() disabledMessage: string;

    @Output() copySuccess: EventEmitter<void> = new EventEmitter<void>();
    @Output() copyFailure: EventEmitter<void> = new EventEmitter<void>();

    constructor(private readonly elRef: ElementRef) {}

    ngOnInit(): void {
        this.container = this.elRef.nativeElement.parentElement;
    }
}
